import ChipColors from '@/app/arch/enums/ChipColors';

export default [
  {
    value: 'Unknown',
    text: 'Desconhecido',
    ...ChipColors.neutral,
  },
  {
    value: 'CashIn',
    text: 'Depósito',
    ...ChipColors.success,
  },
  {
    value: 'CashOut',
    text: 'Saque',
    ...ChipColors.danger,
  },
];
